import PageBanner from "../components/PageBanner";
import { company } from "../data/site";

const facts = [
  { label: "公司名称", value: company.name },
  { label: "英文名称", value: company.englishName },
  { label: "成立日期", value: company.founded },
  { label: "统一社会信用代码", value: company.creditCode },
  { label: "注册资本", value: company.capital },
  { label: "企业类型", value: company.type },
  { label: "所属行业", value: company.industry },
  { label: "控股股东", value: company.parent },
];

export default function Contact() {
  return (
    <div className="inner-page">
      <PageBanner title="联系我们" en="CONTACT" variant="contact" />
      <section className="panel">
        <div className="container split">
          <div>
            <h2 className="small-title">联系方式</h2>
            <div className="contact-block">
              <p>
                <span>地址</span>
                {company.address}
              </p>
              <p>
                <span>邮箱</span>
                <a href={`mailto:${company.email}`}>{company.email}</a>
              </p>
              <p>
                <span>地图</span>
                <a href={company.mapUrl} target="_blank" rel="noreferrer">
                  高德地图查看位置
                </a>
              </p>
            </div>
          </div>
          <div className="fact-table">
            {facts.map((item) => (
              <div key={item.label}>
                <span>{item.label}</span>
                <b>{item.value}</b>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
